import React, { useState } from 'react';
import { Slider } from 'rsuite';
import 'rsuite/Slider/styles/index.css';

import { Card, CardBody } from 'react-bootstrap';

import {
  learnersForPosition,
  priceForPosition,
  SLIDER_MAX_POSITION
} from 'pages/pricing/containers/pricingContainer/constants';

const formatLearners = (learners) => (learners === null ? '10,000+' : learners.toLocaleString());

const CustomTooltip = ({ learners }) => {
  return (
    <div>
      {formatLearners(learners)}&nbsp;
      <small className="d-block" style={{ fontSize: '10px', whiteSpace: 'nowrap' }}>
        Monthly Active Learners
      </small>
    </div>
  );
};

const PriceSlider = () => {
  // The slider holds a position, not a learner count. Deriving both the learner
  // count and the price from that position keeps them consistent by construction.
  const [position, setPosition] = useState(0);

  const learners = learnersForPosition(position);
  const price = priceForPosition(position);

  return (
    <Card className="price-box">
      <CardBody>
        <h4>Calculate Your Cost</h4>
        <p>You will be charged based on the number of monthly active learners you have each month</p>
        <div
          style={{
            '--rs-tooltip-bg': 'var(--rs-slider-progress)',
            '--rs-tooltip-text': 'white',
            '--rs-slider-progress': 'rgb(2, 88, 237)',
            '--rs-slider-thumb-border': 'rgb(2, 88, 237)'
          }}
        >
          <Slider
            progress
            style={{
              marginTop: 26,
              marginBottom: 0,
              width: '70%',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
            step={1}
            min={0}
            max={SLIDER_MAX_POSITION}
            value={position}
            onChange={setPosition}
            renderTooltip={(value) => <CustomTooltip learners={learnersForPosition(value)} />}
          />
          <div className="bar-divider">
            <span>1</span>
            <span>10,000+</span>
          </div>
        </div>
        {price === null ? (
          <h6>Please contact sales department for further information</h6>
        ) : (
          <>
            <h2>${price.toLocaleString()}</h2>
            <small className="d-block text-muted">for {formatLearners(learners)} monthly active learners</small>
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default PriceSlider;
